import { render, staticRenderFns } from "./BannerFragment.vue?vue&type=template&id=b855ac4a&scoped=true&"
import script from "./BannerFragment.vue?vue&type=script&lang=ts&"
export * from "./BannerFragment.vue?vue&type=script&lang=ts&"
import style0 from "./BannerFragment.vue?vue&type=style&index=0&id=b855ac4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b855ac4a",
  null
  
)

export default component.exports